import { render, staticRenderFns } from "./KgjtWebsiteTalentStrategy.vue?vue&type=template&id=4d18554d&scoped=true&"
import script from "./KgjtWebsiteTalentStrategy.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteTalentStrategy.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteTalentStrategy.vue?vue&type=style&index=0&id=4d18554d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18554d",
  null
  
)

export default component.exports